import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.group');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-group',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.group/view.scss */
/* src/app/portal.gsdcadmin.community.group/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityGroupComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public groups: any = [];
    public community: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { id: this.community_id });
        if (code != 200) return window.location="/dashboard";
        this.community = data.community;
        this.groups = data.groups;
        await this.service.render();
    }
}

export default PortalGsdcadminCommunityGroupComponent;